module.exports = __webpack_public_path__ + "static/img/honor-6.7f15577.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-6.png
// module id = load
// module chunks = 0